import React from "react";
import { Link } from "react-router-dom";
import "../../styles/v2/components/breadcrumb.css";

/**
 * Breadcrumb component for navigation trails
 */
const Breadcrumb = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <div className="breadcrumb-container">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.to ? (
            <Link
              to={item.to}
              className="breadcrumb-link"
              onClick={item.onClick} // <-- ADD THIS LINE RIGHT HERE
            >
              {item.label}
            </Link>
          ) : (
            <span className="breadcrumb-text">{item.label}</span>
          )}

          {index < items.length - 1 && (
            <div className="breadcrumb-arrow">
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/breadscrumb_arrow.svg`}
                alt=""
              />
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
